import React from "react";
import { withModal } from "../";

const PrivacyDisclosureModal = ({ context: { closeModal }, ...rest }) => (
  <div
    className="relative bg-white outline-none w-auto h-auto p-10 max-h-screen overflow-auto m-auto"
    style={{ maxHeight: 600, maxWidth: "80%" }}
  >
    <div className="text-center text-2xl p-8">Privacy Disclosure</div>
    <div className="w-5/6 m-auto">
      <p>Message from our third-party service provider, Synapse:</p>
      <br />
      <p>
        We verify your personal identifying details using multiple tools,
        including Synapse’s facial recognition technology. These measures are in
        place for identity verification, financial loss mitigation, and
        regulatory compliance.
      </p>
      <br />
      <p>
        We do not use your data for any other purpose, and we do not sell or
        rent your data to third parties. For more information about how your
        data is collected, used, and stored, please review Synapse’s Privacy
        Policy.
      </p>
    </div>
    <button
      className="absolute top-0 right-0 bg-gray-200 text-white text-2xl m-1 w-10 h-10"
      onClick={closeModal}
    >
      x
    </button>
  </div>
);

export default withModal(PrivacyDisclosureModal);
